import React from 'react';
import { Select, SelectOption } from 'components/ui';

type HeadingSelectorProps = {
  value: string,
  onChange: (v: string | number) => void,
};

const headings = [
  { level: 0, label: 'Normal' },
  { level: 1, label: 'Heading 1' },
  { level: 2, label: 'Heading 2' },
  { level: 3, label: 'Heading 3' },
  { level: 4, label: 'Heading 4' },
  { level: 5, label: 'Heading 5' },
  { level: 6, label: 'Heading 6' },
];

export default function HeadingSelector(props: HeadingSelectorProps) {
  return (
    <Select
      value={props.value}
      onChange={props.onChange}
      style={{ minWidth: '100px' }}
    >
      {headings.map(heading => (
        <SelectOption key={heading.level} value={heading.level}>
          {heading.label}
        </SelectOption>
      ))}
    </Select>
  );
}
